(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["concours-partner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-about-track]');
    const prev = carousel.querySelector('[data-about-prev]');
    const next = carousel.querySelector('[data-about-next]');
    if (!track) return;
    const step = () => {
      const first = track.querySelector('.concours-about__slide');
      if (!first) return track.clientWidth * 0.8;
      const gap = parseFloat(getComputedStyle(track).columnGap || '12') || 12;
      return first.getBoundingClientRect().width + gap;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-en"] && !Shopify.designMode) return;
  try {
    
  // Trust slider — full-width cards on mobile + dynamic pagination dots
  (function () {
    function setupSlider(track) {
      if (track.dataset.trustSliderInit === '1') return;
      track.dataset.trustSliderInit = '1';

      var cards = Array.from(track.children);
      if (cards.length < 2) return;

      // Tag each card with its index
      cards.forEach(function (card, i) {
        card.setAttribute('data-trust-card', '');
        card.setAttribute('data-index', String(i));
      });

      // Build dots container
      var dots = document.createElement('div');
      dots.className = 'trust-mobile-slider__dots';
      dots.setAttribute('aria-hidden', 'true');
      cards.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'trust-mobile-slider__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('data-dot-index', String(i));
        dots.appendChild(dot);
      });

      // Wrap the slider in our own container so the dots can sit cleanly below
      // without fighting the parent's grid/flex/card layout.
      var wrapper = document.createElement('div');
      wrapper.className = 'trust-mobile-slider__wrap';
      track.parentNode.insertBefore(wrapper, track);
      wrapper.appendChild(track);
      wrapper.appendChild(dots);

      if (!('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var i = parseInt(entry.target.getAttribute('data-index'), 10);
          dots.querySelectorAll('[data-dot-index]').forEach(function (dot, idx) {
            dot.classList.toggle('is-active', idx === i);
          });
        });
      }, { root: track, threshold: 0.6 });
      cards.forEach(function (card) { observer.observe(card); });
    }

    function init() {
      document.querySelectorAll('.trust-mobile-slider').forEach(setupSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Trust slider — full-width cards on mobile + dynamic pagination dots
  (function () {
    function setupSlider(track) {
      if (track.dataset.trustSliderInit === '1') return;
      track.dataset.trustSliderInit = '1';

      var cards = Array.from(track.children);
      if (cards.length < 2) return;

      // Tag each card with its index
      cards.forEach(function (card, i) {
        card.setAttribute('data-trust-card', '');
        card.setAttribute('data-index', String(i));
      });

      // Build dots container
      var dots = document.createElement('div');
      dots.className = 'trust-mobile-slider__dots';
      dots.setAttribute('aria-hidden', 'true');
      cards.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'trust-mobile-slider__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('data-dot-index', String(i));
        dots.appendChild(dot);
      });

      // Wrap the slider in our own container so the dots can sit cleanly below
      // without fighting the parent's grid/flex/card layout.
      var wrapper = document.createElement('div');
      wrapper.className = 'trust-mobile-slider__wrap';
      track.parentNode.insertBefore(wrapper, track);
      wrapper.appendChild(track);
      wrapper.appendChild(dots);

      if (!('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var i = parseInt(entry.target.getAttribute('data-index'), 10);
          dots.querySelectorAll('[data-dot-index]').forEach(function (dot, idx) {
            dot.classList.toggle('is-active', idx === i);
          });
        });
      }, { root: track, threshold: 0.6 });
      cards.forEach(function (card) { observer.observe(card); });
    }

    function init() {
      document.querySelectorAll('.trust-mobile-slider').forEach(setupSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
